<section class="main">
    <h3>Add new member</h3>

    <div>
        <label>Select Type</label>
        <div class="dropdown mb-0 ">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{chooseType}}
                <img src="assets/images/mangeunit/arrow.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                <li (click)="gettaype('staff')">
                    <a class="dropdown-item">
                        Staff
                    </a>
                </li>
                <li (click)="gettaype('vip')">
                    <a class="dropdown-item">
                        VIP
                    </a>
                </li>
            </ul>
        </div>

        <div class="waring" *ngIf="submitted && chooseType == 'choose Type' ">
            Type is required
        </div>
    </div>


    <div *ngIf="chooseType != 'choose Type'">
        <label class="mt-3">Select Category</label>
        <div class="dropdown mb-0 ">
            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{chooseCtegory}}
                <img src="assets/images/mangeunit/arrow.png">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                <li *ngFor="let item of cat_arr">
                    <a class="dropdown-item" (click)="getCat(item)">
                        {{item.name}}
                    </a>
                </li>
            </ul>
        </div>
        <div class="waring" *ngIf="submitted && chooseCtegory == 'choose Category' ">
            Category is required
        </div>
    </div>


    <form #form="ngForm">
        <div class="row mt-3">
            <div class="col-12">
                <div class="form-group">
                    <label>Name</label>
                    <input required name="name" [ngClass]="{ 'is-invalid': submitted && name == '' }" [(ngModel)]="name"
                        name="name" placeholder="EX. Home" type="text" class="form-control">
                </div>
            </div>
            <div class="col-12 mt-3">
                <label>From</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input class="form-control" [ngClass]="{ 'is-invalid': submitted && dateFrom == '' }"
                        [(ngModel)]="dateFrom" name="dateFrom" placeholder="yyyy/mm/dd" [matDatepicker]="pickerfrom">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerfrom></mat-datepicker>
                </div>
            </div>
            <div class="col-12">
                <label>To</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input class="form-control" [ngClass]="{ 'is-invalid': submitted && dateTo == '' }"
                        [(ngModel)]="dateTo" name="dateTo" placeholder="yyyy/mm/dd" [matDatepicker]="pickerto">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerto"></mat-datepicker-toggle>
                    <mat-datepicker #pickerto></mat-datepicker>
                </div>
            </div>
        </div>


        <div class="addUnits d-flex justify-content-end mt-5 mb-2">
            <div>
                <button mat-dialog-close class="btn me-2">Cancel</button>
                <button (click)="addMemebr(form)" class="btn addUnit">Add Member</button>
            </div>
        </div>
    </form>
</section>